import React from 'react';
import './Steps.css';

const Step1 = ({ bookingData, updateBookingData, nextStep }) => {
  const [selectedSport, setSelectedSport] = React.useState(bookingData.sport || '');
  const [selectedType, setSelectedType] = React.useState('single');
  const [groupSize, setGroupSize] = React.useState(bookingData.numberOfParticipants || 3);

  const handleSelectSport = (sport) => {
    setSelectedSport(sport);
    updateBookingData('sport', sport);
  };

  const handleSelectType = (type) => {
    setSelectedType(type);
    if (type === 'single') {
      updateBookingData('numberOfParticipants', 1);
    } else if (type === 'couple') {
      updateBookingData('numberOfParticipants', 2);
    } else if (type === 'group') {
      setGroupSize(3);
      updateBookingData('numberOfParticipants', 3);
    }
  };

  const handleGroupSizeChange = (increment) => {
    const newSize = increment ? groupSize + 1 : Math.max(3, groupSize - 1);
    setGroupSize(newSize);
    if (selectedType === 'group') {
      updateBookingData('numberOfParticipants', newSize);
    }
  };

  const handleNext = () => {
    if (selectedSport && bookingData.numberOfParticipants > 0) {
      nextStep();
    }
  };

  return (
    <div className="step-container">
      <h2 className="step-heading">Ce sport doriți să practicați?</h2>
      <p className="step-description">Selectați sportul pentru lecțiile dvs.</p>
      <div className="step-info-note">
  <div>📍 Locație: Pârtia ICOANA Cavnic</div>
  <a href="https://maps.google.com/?q=Pârtia+ICOANA+Cavnic" target="_blank" rel="noopener noreferrer" className="location-link">Deschide în Maps</a>
</div>
      <div className="sport-selection-grid">
        <button
          className={`sport-card ${selectedSport === 'ski' ? 'selected' : ''}`}
          onClick={() => handleSelectSport('ski')}
        >
          <div className="sport-icon">⛷️</div>
          <div className="sport-title">Schi</div>
        </button>

        <button
          className={`sport-card ${selectedSport === 'snowboard' ? 'selected' : ''}`}
          onClick={() => handleSelectSport('snowboard')}
        >
          <div className="sport-icon">🏂</div>
          <div className="sport-title">Snowboard</div>
        </button>
      </div>

      {selectedSport && (
        <>
          <div className="section-divider"></div>
          
          <h2 className="step-heading">Câți participanți veți fi?</h2>
          <p className="step-description">Selectați numărul de persoane care vor participa la lecții</p>
          
          <div className="participants-type-grid">
            <button
              className={`participant-type-card ${selectedType === 'single' ? 'selected' : ''}`}
              onClick={() => handleSelectType('single')}
            >
              <div className="participant-icon">👤</div>
              <div className="participant-type-title">1 Persoană</div>
              <div className="participant-type-desc">Doar eu</div>
            </button>

            <button
              className={`participant-type-card ${selectedType === 'couple' ? 'selected' : ''}`}
              onClick={() => handleSelectType('couple')}
            >
              <div className="participant-icon">👥</div>
              <div className="participant-type-title">2 Persoane</div>
              <div className="participant-type-desc">Cuplu sau prieteni</div>
            </button>

            <button
              className={`participant-type-card ${selectedType === 'group' ? 'selected' : ''}`}
              onClick={() => handleSelectType('group')}
            >
              <div className="participant-icon">👥👥👥</div>
              <div className="participant-type-title">Grup</div>
              <div className="participant-type-desc">3+ persoane</div>
            </button>
          </div>

          {selectedType === 'group' && (
            <div className="group-size-selector">
              <label className="group-size-label">Selectați numărul de participanți în grup:</label>
              <div className="group-counter">
                <button 
                  className="counter-btn"
                  onClick={() => handleGroupSizeChange(false)}
                  disabled={groupSize <= 3}
                >
                  -
                </button>
                <span className="counter-display">{groupSize} persoane</span>
                <button 
                  className="counter-btn"
                  onClick={() => handleGroupSizeChange(true)}
                >
                  +
                </button>
              </div>
            </div>
          )}
        </>
      )}

      <div className="step-actions">
        <button 
          className="btn-primary btn-next"
          onClick={handleNext}
          disabled={!selectedSport || !bookingData.numberOfParticipants}
        >
          Continuă
        </button>
      </div>
    </div>
  );
};

export default Step1;